import Icon from '@/components/ui/AppIcon';

interface ContactInfo {
  icon: string;
  title: string;
  details: string[];
}

export default function ContactInfoSection() {
  const contactInfo: ContactInfo[] = [
    {
      icon: 'MapPinIcon',
      title: 'Office',
      details: [
        'Cialfor Research Labs Private Limited',
        '2nd Floor, GreyStone by Tremont, Opposite SBI, Veerbhadra Nagar, Baner',
        'Pune, Maharashtra 411045'
      ]
    },
    {
      icon: 'PhoneIcon',
      title: 'Phone',
      details: [
        'Main Office: +91 7066 784 824'
      ]
    },
    {
      icon: 'EnvelopeIcon',
      title: 'Email',
      details: [
        'info@cialfor.com'
      ]
    },
    {
      icon: 'ClockIcon',
      title: 'Business Hours',
      details: [
        'Monday - Friday: 10:00 AM - 6:00 PM IST',
        'Saturday: Closed',
        'Sunday: Closed'
      ]
    }
  ];

  return (
    <div data-component-id="src/app/contact/components/ContactInfoSection.tsx:46:4" data-component-path="src/app/contact/components/ContactInfoSection.tsx" data-component-line="46" data-component-file="ContactInfoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {contactInfo.map((info, index) => (
        <div data-component-id="src/app/contact/components/ContactInfoSection.tsx:48:8" data-component-path="src/app/contact/components/ContactInfoSection.tsx" data-component-line="48" data-component-file="ContactInfoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-surface%20rounded-xl%20p-6%20shadow-card%20border%20border-border%22%7D" key={index} className="bg-surface rounded-xl p-6 shadow-card border border-border">
          <div data-component-id="src/app/contact/components/ContactInfoSection.tsx:49:10" data-component-path="src/app/contact/components/ContactInfoSection.tsx" data-component-line="49" data-component-file="ContactInfoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20space-x-3%20mb-4%22%7D" className="flex items-center space-x-3 mb-4">
            <div data-component-id="src/app/contact/components/ContactInfoSection.tsx:50:12" data-component-path="src/app/contact/components/ContactInfoSection.tsx" data-component-line="50" data-component-file="ContactInfoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-12%20h-12%20bg-accent%2F10%20rounded-lg%20flex%20items-center%20justify-center%22%7D" className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center">
              <Icon data-component-id="src/app/contact/components/ContactInfoSection.tsx:51:14" data-component-path="src/app/contact/components/ContactInfoSection.tsx" data-component-line="51" data-component-file="ContactInfoSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-accent%22%7D" name={info.icon as any} size={24} className="text-accent" variant="outline" />
            </div>
            <h3 data-component-id="src/app/contact/components/ContactInfoSection.tsx:53:12" data-component-path="src/app/contact/components/ContactInfoSection.tsx" data-component-line="53" data-component-file="ContactInfoSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-bold%20text-text-primary%22%7D" className="font-bold text-text-primary">{info.title}</h3>
          </div>
          <div data-component-id="src/app/contact/components/ContactInfoSection.tsx:55:10" data-component-path="src/app/contact/components/ContactInfoSection.tsx" data-component-line="55" data-component-file="ContactInfoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-2%22%7D" className="space-y-2">
            {info.details.map((detail, idx) => {
  // Email
  if (info.title === 'Email') {
    return (
      <p data-component-id="src/app/contact/components/ContactInfoSection.tsx:60:6" data-component-path="src/app/contact/components/ContactInfoSection.tsx" data-component-line="60" data-component-file="ContactInfoSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20leading-relaxed%22%7D" key={idx} className="text-sm leading-relaxed">
        <a data-component-id="src/app/contact/components/ContactInfoSection.tsx:61:8" data-component-path="src/app/contact/components/ContactInfoSection.tsx" data-component-line="61" data-component-file="ContactInfoSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22text-accent%20hover%3Aunderline%22%7D"
          href={`mailto:${detail}`}
          className="text-accent hover:underline"
        >
          {detail}
        </a>
      </p>
    );
  }

  // Phone
  if (info.title === 'Phone') {
    const phoneNumber = detail.replace(/[^+\d]/g, '');
    return (
      <p data-component-id="src/app/contact/components/ContactInfoSection.tsx:75:6" data-component-path="src/app/contact/components/ContactInfoSection.tsx" data-component-line="75" data-component-file="ContactInfoSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20leading-relaxed%22%7D" key={idx} className="text-sm leading-relaxed">
        <a data-component-id="src/app/contact/components/ContactInfoSection.tsx:76:8" data-component-path="src/app/contact/components/ContactInfoSection.tsx" data-component-line="76" data-component-file="ContactInfoSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22text-accent%20hover%3Aunderline%22%7D"
          href={`tel:${phoneNumber}`}
          className="text-accent hover:underline"
        >
          {detail}
        </a>
      </p>
    );
  }

  // Default (address, hours, etc.)
  return (
    <p data-component-id="src/app/contact/components/ContactInfoSection.tsx:88:4" data-component-path="src/app/contact/components/ContactInfoSection.tsx" data-component-line="88" data-component-file="ContactInfoSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-text-secondary%20leading-relaxed%22%7D" key={idx} className="text-sm text-text-secondary leading-relaxed">
      {detail}
    </p>
  );
})}

          </div>
        </div>
      ))}
    </div>
  );
}